export enum BrowseViewMode {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}